import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
import VueSidebarMenu from 'vue-sidebar-menu';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';


Vue.use(BootstrapVue);
Vue.use(VueSidebarMenu);

Vue.config.productionTip = true;
Vue.prototype.$hostname = (Vue.config.productionTip) ? '' : 'http://localhost:8080';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
